import { render, staticRenderFns } from "./SettingsPopup.vue?vue&type=template&id=43761e53"
import script from "./SettingsPopup.vue?vue&type=script&lang=js"
export * from "./SettingsPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports